import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { node } from "../../Axios";
import { loading_login, logout } from "../../store/actions/login";
import {
  get_ordini_aperti_sala,
  send_ordine_success,
  set_coperti,
  set_formula,
  set_ordine,
  set_storico_ordine,
  set_storico_uscite_ordine,
  set_tavolo,
  set_tipo,
  set_totale_generale,
  stampa_ombrellone,
  stampa_qr_tavolo,
  togglenavcat,
} from "../../store/actions/ordini";
import { getSession } from "../../utils/session";
import Spinner from "../Spinner";
import Table from "../TableOrdiniAperti";
/* import Pusher from "pusher-js"; */


const FirstTab = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const ordini = useSelector((state) => state.ordini.ordini);
  const loading = useSelector((state) => state.ordini.loading);
  const loading2 = useSelector((state) => state.login.loading);
  const id_ruolo = useSelector((state) => state.login.id_ruolo);
  
  useEffect(() => {
    async function fetchordini() {
      await dispatch(loading_login(true));
      await dispatch(get_ordini_aperti_sala());
      await dispatch(send_ordine_success());

      await dispatch(loading_login(false));
    }

    fetchordini();
  }, []);
  const chiudiordine = async (id_ordine,tipo) => {
  
    try {
      await dispatch(loading_login(true));
      const sessione = await getSession();
      const config = {
        headers: { Authorization: `Bearer ${sessione.token}` },
      };

      const bodyParameters = {
        id_ordine: id_ordine,
        tipo:tipo
      };
      const res = await node.post(
        "/api/ordini/chiudiordine",
        bodyParameters,
        config
      );
      console.log(res)
      await dispatch(get_ordini_aperti_sala());
      await dispatch(loading_login(false));
    } catch (error) {
      if (error.response.status == "401") {
        dispatch(logout());
      }
      if (error.response.status == "422") {
        console.log(error.response);
      }
    }
  };
  const ordina = async (
    id_ordine,
    coperti,
    tot_generale,
    tavolo,
    id_formula,
    storico,
    storico_uscite,tipo
  ) => {
    console.log("sono qui");
    await dispatch(set_storico_ordine(storico));
    await dispatch(set_storico_uscite_ordine(storico_uscite));
    await dispatch(togglenavcat(true));

    await dispatch(set_tavolo(tavolo));
    await dispatch(set_ordine(id_ordine));
    await dispatch(set_formula(id_formula));
    await dispatch(set_totale_generale(tot_generale));
    await dispatch(set_coperti(coperti));
    await dispatch(set_tipo(tipo));

    navigate(`../products/${id_ordine}/2/0`);
  };
  const stampaQr= async (id) => {
    await dispatch(loading_login(true));
    if (await dispatch(stampa_qr_tavolo(id))) 
    await dispatch(loading_login(false));
  };
  return (
    <div className="content-tab">
      <div className="titolo-tab">Ordini Aperti!</div>
      {loading || loading2 ? (
        <Spinner />
      ) : ordini != 0 ? (
        <div className="contenuto-ordini">
          <Table
            ordini={ordini}
            chiudiordine={chiudiordine}
            stapmaqr={stampaQr}
            ordina={ordina}
            ruolo={id_ruolo}
          />
        </div>
      ) : (
        "Non sono ancora presenti ordini aperti"
      )}
    </div>
  );
};
export default FirstTab;




// Esempio di utilizzo

